import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b05e175c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sync" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_3 = { for: "roomId" }
const _hoisted_4 = { class: "form-control" }
const _hoisted_5 = {
  key: 0,
  class: "user-feedback-alert"
}
const _hoisted_6 = {
  key: 1,
  class: "user-feedback-alert"
}
const _hoisted_7 = {
  key: 2,
  class: "user-feedback-alert"
}
const _hoisted_8 = {
  key: 1,
  class: "user-feedback-success"
}
const _hoisted_9 = { class: "user-feedback-success-inner" }
const _hoisted_10 = { class: "icon-synced" }

import { ref, watch, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'

import gsap from 'gsap'

import { useAppState } from '@/services/composition';
import UIOtpInput from '@/components/UIOtpInput/UIOtpInput.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const { state, send } = useAppState()

const roomId = ref('')
watch(roomId, (roomId) => {
  if (roomId.length >= 4) {
    tryJoinRoom(roomId)
  }
})

const onChange = (value) => {
  roomId.value = value
}

const showForm = computed(() => {
  return !state.value.matches('sync.connect.companion.completed') && !isSynced.value
})

const isSynced = computed(() => {
  return state.value.matches('sync.synced')
})

const isLoading = computed(() => {
  return state.value.matches('sync.connect.companion.connect')
})

const isFullRoom = computed(() => {
  return state.value.matches('sync.connect.companion.fullroom')
})

const isUnknown = computed(() => {
  return state.value.matches('sync.connect.companion.unknown')
})

const tryJoinRoom = (roomId: string) => {
  send( { type:'COMPANION_JOIN_ROOM', payload: roomId })
}

const formEl = ref(null)
const viewportHandler = (event) => {
  const viewport = event.target
  const bcr = formEl.value.getBoundingClientRect()
  const y = viewport.height * 0.5 - (bcr.top + bcr.height) * 0.5
  gsap.set(formEl.value, { y, duration: 0.5 })
}

onMounted(()=> {
  window.visualViewport.addEventListener('resize', viewportHandler);
})

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_Transition, {
      name: "medium-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_unref(showForm))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "formEl",
              ref: formEl,
              class: "form"
            }, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)('sync.companion.title')), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(UIOtpInput, {
                  value: roomId.value,
                  valueLength: 4,
                  onOnChange: onChange
                }, null, 8, ["value"])
              ]),
              _createVNode(_Transition, {
                name: "medium-fade",
                appear: ""
              }, {
                default: _withCtx(() => [
                  (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('sync.loading')), 1))
                    : (_unref(isFullRoom))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('sync.room_full')), 1))
                      : (_unref(isUnknown))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('sync.room_unknown')), 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512))
          : (_unref(isSynced))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(t)('sync.synced')) + " ", 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ui_icon, { name: "checkmark" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})